import { Component } from "vue-property-decorator";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { UserLoggedInfoModel } from "@/models/userModels";
import baseContextComponent from "./baseContextComponent";

@Component({
	computed: {
		...mapGetters([
			"getUser",
			"getIsAuthenticated",
			"getUserFirstName",
			"getUserLastName",
			"getUserId",
			"getUserRole"
		])
	}
})
export default class baseUserContextComponent extends baseContextComponent {
	getUser!: UserLoggedInfoModel;
	getIsAuthenticated: boolean;
	getUserFirstName: string;
	getUserLastName: number | null;
	getUserId: string;
	getUserRole: string;
}
